<template>
  <button @click="clickAction" :style="cssStyle" class="defaultStyle">
    <span>
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  emits: ["clickAction"],
  props: {
    borderRadius: {
      type: String,
      default: "5px",
    },
    border: {
      type: String,
      default: "none",
    },
    color: {
      type: String,
      default: "white",
    },
    width: {
      type: Number,
      default: 165,
    },
    height: {
      type: Number,
      default: 40,
    },
    fontFamily: {
      type: String,
      default: "Lato",
    },
    fontSize: {
      type: String,
      default: "15px",
    },
    display: {
      type: String,
      default: "inline-block",
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssStyle() {
      return {
        border: this.border,
        borderRadius: this.borderRadius,
        color: this.color,
        width: !isNaN(this.width) ? this.width + "px" : this.width,
        height: this.height + "px",
        fontFamily: this.fontFamily,
        fontSize: this.fontSize,
        display: this.display,
      };
    },
  },
  methods: {
    clickAction(event) {
      if (!this.disable) {
        event.preventDefault();
        this.$emit("clickAction");
      }
    },
  },
};
</script>

<style>
.defaultStyle {
  padding: 0px;
  cursor: pointer;
  background-color: var(--btn-background);
}
.defaultStyle:hover {
  background-color: var(--btn-background-hover);
}
</style>
